<div leaflet id="map" style="height: 100%; width: 100%; border-radius: 8px;" [leafletOptions]="options"
	class="mat-typography" [leafletBaseLayers]="baseLayers" (leafletMapReady)="onMapReady($event)"
	[leafletLayersControlOptions]="layersControlOptions" [leafletMarkerCluster]="markerClusterData"
	[leafletMarkerClusterOptions]="markerClusterOptions" (leafletMarkerClusterReady)="markerClusterReady($event)">
</div>
